import { zodResolver } from '@hookform/resolvers/zod'
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'
import { z } from 'zod'

const loginSchema = z.object({
  email: z.string().email('Ogiltig e-postadress'),
  password: z.string().min(6, 'Lösenord måste vara minst 6 tecken'),
})

export type LoginFormData = z.infer<typeof loginSchema>

export const useLoginForm = () => {
  const form = useForm<LoginFormData>({
    resolver: zodResolver(loginSchema),
    defaultValues: {
      email: '',
      password: '',
    },
  })

  const onSubmit = async (data: LoginFormData) => {
    const auth = getAuth()
    signInWithEmailAndPassword(auth, data.email, data.password)
      .then(userCredential => {
        // Signed in
        // const user = userCredential.user
        toast.success('Inloggad!')
      })
      .catch(error => {
        const errorCode = error.code
        const errorMessage = error.message
        console.error('Firebase login error', errorCode, errorMessage)
        toast.error(errorMessage)
      })
  }

  return { form, onSubmit: form.handleSubmit(onSubmit) }
}
